import React, { useRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Button } from '@heroui/react';
import { navigate } from 'gatsby';
import { Black, white } from '../../../../../cra/src/styling/theme';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const Wrap = styled.div`
  color: ${Black};
  display: grid;
  grid-column-gap: 1.5rem;

  @media ${breakpointsMinWidth.mobileMd} {
    grid-column: 1/-1;
    grid-template-columns: repeat(4, 1fr);
    margin: 48px 0px 0px 0px;
    align-items: center;
  }

  @media ${breakpointsMinWidth.mobileMicroLg} {
    margin: 48px 0px 0px 0px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    display: grid;
    grid-column: 1/-1;
    grid-column-gap: 1.5rem;

    grid-template-columns: repeat(8, 1fr);
    margin: 64px 0px 0px 0px;
    padding: 0 20px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 1/-1;

    grid-template-columns: repeat(12, 1fr);
    margin: 64px 0px 0px 0px;
    padding: 0;
  }

  @media ${breakpointsMinWidth.tabletLg} {
    margin: 64px 0px 0px 0px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    margin: 64px 0px 0px 0px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    margin: 108px 0px 0px 0px;
    margin-top: ${(props) => (props.index === 0 ? '80px' : '108px')};
  }
`;

const ContentImgContainer = styled.div`
  opacity: 0;
  filter: blur(2px);
  transform: ${(props) =>
    props.index % 2 > 0 ? 'translateX(10%)' : 'translateX(-10%)'};
  ${(props) => {
    if (props.elementVisibilty) {
      return css`
        opacity: 1;
        filter: blur(0);
        transform: translateX(0);
        transition: all 1.5s;
      `;
    }
    return null;
  }}

  @media ${breakpointsMinWidth.mobileMd} {
    grid-column: 1/5;
    padding: 0px 24px 0px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    padding: 0px;
    grid-column: ${(props) => (props.index % 2 > 0 ? '5/9' : '1/5')};
  }
  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '7/12' : '2/7')};
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 24px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '7/11' : '3/7')};
    padding: 0px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '7/11' : '3/7')};
    padding: 0px;
  }
`;

const ContentImg = styled.img`
  background: ${white};
  box-shadow: 0px 0px 48px rgba(15, 28, 53, 0.15);
  border-radius: 16px;
  width: 100%;
`;
const ContentVideo = styled.iframe`
  background: ${white};
  box-shadow: 0px 0px 48px rgba(15, 28, 53, 0.15);
  border-radius: 16px;
  width: 100%;
  height: 247px;

  @media ${breakpointsMinWidth.tabletSm} {
    height: 258px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    height: 304px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    height: 348px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    height: 344px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    height: 464px;
  }
`;

const ContentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  opacity: 0;
  filter: blur(2px);
  transform: ${(props) =>
    props.index % 2 > 0 ? 'translateX(10%)' : 'translateX(-10%)'};
  ${(props) => {
    if (props.elementVisibilty) {
      return css`
        opacity: 1;
        filter: blur(0);
        transform: translateX(0);
        transition: all 1.5s;
      `;
    }
    return null;
  }}

  @media ${breakpointsMinWidth.mobileMd} {
    grid-column: 1/5;
    width: 100%;
    padding: 0px 24px 0px;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    text-align: start;
    height: 100%;
    width: 100%;
    justify-content: center;
    grid-column: ${(props) => (props.index % 2 > 0 ? '1/5' : '5/9')};
    grid-row: 1/2;
    padding: 0px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '2/7' : '7/12')};
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 24px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '3/7' : '7/11')};
    padding: 0px;
    padding: ${(props) => (props.index % 2 > 0 ? '0 90px 0 0' : '0 0 0 90px')};
  }
  @media ${breakpointsMinWidth.desktopMd} {
    grid-column: ${(props) => (props.index % 2 > 0 ? '3/6' : '8/11')};
    padding: 0px;
  }
`;

const ContentHeadingP = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  margin: 20px 0px 8px 0px;
  color: #2364eb;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 18px;
    margin: 0px 0px 8px 0px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 20px;
    line-height: 23px;
    margin: 0px 0px 14px 0px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin: 0px 0px 8px 0px;
    margin: 0px 0px 16px 0px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 20px;
    margin: 0px 0px 16px 0px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 24px;
    line-height: 28px;
    margin: 0px 0px 12px 0px;
  }
`;

const ContentSubheadinP = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin: 0 0 18px 0;
  color: #222;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 16px;
    line-height: 19px;
    margin: 0 0 18px 0;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 18px;
    line-height: 21px;
    margin: 0 0 26px 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin: 0 0 32px 0;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
    line-height: 23px;
    margin: 0 0 28px 0;
  }
`;

const ContentTextP = styled.p`
  font-weight: 400;
  font-size: 14px;
  margin: 0px;
  color: #3c3c3c;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 14px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    font-size: 16px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
  }
`;

const Content = ({ index, child }) => {
  const myref = useRef();
  const [elementVisibilty, setMyElementVisible] = useState();
  const {
    imgUrl,
    alt,
    subHeading1,
    heading1,
    text,
    isVideo,
    videoUrl,
    buttonUrl,
  } = child;

  const handleObserverCallBack = (entries) => {
    const entry = entries[0];
    if (entry.intersectionRatio >= 0.2 && entry.isIntersecting) {
      setMyElementVisible(entry.isIntersecting);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserverCallBack, {
      threshold: [0, 0.2],
    });
    observer.observe(myref.current);
  }, []);

  return (
    <>
      <Wrap ref={myref} index={index}>
        {!isVideo && (
          <ContentImgContainer
            index={index}
            elementVisibilty={elementVisibilty}
          >
            <ContentImg loading="lazy" src={imgUrl} alt={alt} />
          </ContentImgContainer>
        )}
        {isVideo && (
          <ContentImgContainer
            index={index}
            elementVisibilty={elementVisibilty}
          >
            <ContentVideo
              className="w-full rounded-xl"
              src={videoUrl}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              title="Wisedoc Tutorials"
            />
          </ContentImgContainer>
        )}

        <ContentTextContainer index={index} elementVisibilty={elementVisibilty}>
          <ContentHeadingP>{heading1}</ContentHeadingP>
          <ContentSubheadinP>{subHeading1}</ContentSubheadinP>
          <ContentTextP>{text}</ContentTextP>
          {buttonUrl && (
            <Button
              onClick={() => navigate(buttonUrl)}
              color="primary"
              className="w-[104px] h-[45px] rounded-[16px] mt-[24px] tabletSm:mt-[34px] tabletMd:mt-[20px] tabletLg:mt-[32px] desktopSm:mt-[24px] self-center tabletSm:self-start"
              variant="bordered"
            >
              Learn More
            </Button>
          )}
        </ContentTextContainer>
      </Wrap>
    </>
  );
};

export default Content;
